/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ label: NonNullable<unknown> }} Statement_Taxonomy_Editor_Remove_RowInputs */

const en_statement_taxonomy_editor_remove_row = /** @type {(inputs: Statement_Taxonomy_Editor_Remove_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Remove ${i?.label}`)
};

const nl_statement_taxonomy_editor_remove_row = /** @type {(inputs: Statement_Taxonomy_Editor_Remove_RowInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.label} verwijderen`)
};

/**
* | output |
* | --- |
* | "Remove {label}" |
*
* @param {Statement_Taxonomy_Editor_Remove_RowInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const statement_taxonomy_editor_remove_row = /** @type {((inputs: Statement_Taxonomy_Editor_Remove_RowInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Statement_Taxonomy_Editor_Remove_RowInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_statement_taxonomy_editor_remove_row(inputs)
	return en_statement_taxonomy_editor_remove_row(inputs)
});